import React from 'react';
import { Link } from 'react-router-dom';
import './HamburgerMenu.css';

function HamburgerMenu({ isOpen, onClose }) {
  return (
    <div className={`hamburger-menu ${isOpen ? 'open' : ''}`}>
      <div className="menu-overlay" onClick={onClose}></div>
      <div className="menu-content">
        <button className="close-menu" onClick={onClose}>×</button>
        <div className="menu-header">
          <h2>NyotaFund</h2>
        </div>
        <nav className="menu-nav">
          <Link to="/" onClick={onClose}>Home</Link>
          <Link to="/contact" onClick={onClose}>Contact Us</Link>
          <Link to="/about" onClick={onClose}>About App</Link>
          <Link to="/rate-app" onClick={onClose}>Rate App</Link>
        </nav>
        <div className="menu-footer">
          <button className="share-btn">Share App</button>
        </div>
      </div>
    </div>
  );
}

export default HamburgerMenu;